export default {
  authData: null,
  userData: null,
  userList: [],
  lastCookieCheck: 0,
  numSnapshotsProcessed: 0,
  dumpFiles: [],
  flags: [],
  restarting: false
};
